import React, { useState } from "react";
import { useForm } from "../../../Hooks/UseForm";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import banesco from "../../../assets/bancos/newLogos/banesco-50.png";
import mercantil from "../../../assets/bancos/newLogos/mercantil-50.png";
import bancoVenezuela from "../../../assets/bancos/newLogos/bdv-50.png";
import bbva from "../../../assets/bancos/newLogos/provincial.png";
import otroBanco from "../../../assets/bancos/newLogos/otrobanco.png";
import { CheckCircleIcon } from "@heroicons/react/solid";
import pagos from "../../../assets/svg/pagos2-azul.svg";
import { UseContextApp } from "../../../Global/Context/appContext";
import {ArrowLeftIcon} from "@heroicons/react/solid";

function TypeDomiciliacionInst() {

  const [loading, setLoading] = useState(false);
  const [icon, setIcon] = useState(false);
  const location = useLocation();
  const pathName = location.pathname;
  const navigate = useNavigate();
  const volver = async () => { window.location.href = '/cuenta/pagos'; };
  const [descripDom, setDescripDom] = useState(localStorage.getItem('descripDom'))
  const [nroCuenta, setNroCuenta] = useState(localStorage.getItem('nroCuenta'))
  const [tipoDoc, setTipoDoc] = useState("");
  const [{ user }] = UseContextApp();


  const domiciliacionBanco = (value) => {
    let resTipoDom = "";
    let descripDom = "";
    switch (value) {
      case 1:
        resTipoDom = "1";
        setTipoDoc(resTipoDom);
        descripDom = "BBVA";
        localStorage.setItem('descripDomBanco', descripDom);
        navigate('/cuenta/domiciliacion/domiciliacion-debito');
        break;
      case 2:
        resTipoDom = "2";
        setTipoDoc(resTipoDom);
        descripDom = "Banesco";
        localStorage.setItem('descripDomBanco', descripDom);
        navigate('/cuenta/domiciliacion/domiciliacion-debito');
        break;
      case 3:
        resTipoDom = "3";
        setTipoDoc(resTipoDom);
        descripDom = "BDV";
        localStorage.setItem('descripDomBanco', descripDom);
        navigate('/cuenta/domiciliacion/domiciliacion-debito');
        break;
      case 4:
        resTipoDom = "4";
        setTipoDoc(resTipoDom);
        descripDom = "Mercantil";
        localStorage.setItem('descripDomBanco', descripDom);
        navigate('/cuenta/domiciliacion/domiciliacion-debito');
        break;
      case 5:
        resTipoDom = "5";
        setTipoDoc(resTipoDom);
        descripDom = "Otro Banco";
        localStorage.setItem('descripDomBanco', descripDom);
        navigate('/cuenta/domiciliacion/domiciliacion-debito');
        break;
    }
  };

  const back = () => {
    navigate('/cuenta/pagos');
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        <div className="flex lg:w-full gap-5 px-4  flex-col">
          <BreadCrumbsGeneric locations={pathName} />
          <button
                className="bg-white w-[40%] md:w-[10%] h-11 flex justify-center items-center rounded-md shadow px-6  space-x-4"
                onClick={() => back()}
              >
                <div className="flex w-full justify-between items-center">
                  <div>
                    <ArrowLeftIcon className="h-5 w-5" />
                  </div>
                  <div>Volver</div>
                </div>
              </button>
          <div className="bg-white rounded-[10px] py-5 lg:py-0 border-b border-gray-200 lg:px-0 px-6">
            <div className=" py-6 px-6 sm:px-6">
              <div className="py-2 text-2xl font-medium ">
                Domicilia el Pago de tus Servicios
              </div>
              <div className=" text-lg font-regular ">
              Selecciona la entidad bancaria o la opción otros bancos.
              </div>
            </div>
            <div class="lg:p-[30px] w-full">
              <div className="flex justify-end flex-col md:flex-row items-center gap-5 ">
                <button
                  onClick={() => domiciliacionBanco(1)}
                  className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "1"
                      ? "border-[#5ab9e5] border-[2px]  "
                      : "border-gray-300 "
                    }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[15%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                  }
                >
                  {tipoDoc === "1" && (
                    <CheckCircleIcon
                      className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                      aria-hidden="true"
                    />
                  )}
                  <div class=" w-[80px] transition-all  duration-300 ">
                    <img class="fill-orange-500 w-full object-contain h-[80px] " src={bbva} alt="" />
                  </div>
                  <div class="flex h-full flex-col-reverse gap-4 w-full justify-center items-center ">
                    <span class="block text-lg" id="headlessui-label-:rt:"><span class="text-[#a0a0a0]   transition-all  duration-100 ">BBVA</span></span>
                  </div>
                </button>
                <button
                  onClick={() => domiciliacionBanco(2)}
                  className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "2"
                      ? "border-[#5ab9e5] border-[2px]  "
                      : "border-gray-300 "
                    }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[15%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                  }
                >
                  {tipoDoc === "2" && (
                    <CheckCircleIcon
                      className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                      aria-hidden="true"
                    />
                  )}
                  <div class=" w-[80px] transition-all  duration-300 ">
                    <img class="fill-orange-500 w-full object-contain h-[80px] " src={banesco} alt="" />
                  </div>
                  <div class="flex h-full flex-col-reverse gap-4 w-full justify-center items-center ">
                    <span class="block text-lg" id="headlessui-label-:rt:"><span class="text-[#a0a0a0]   transition-all  duration-100 ">Banesco</span></span>
                  </div>
                </button>
                <button
                  onClick={() => domiciliacionBanco(3)}
                  className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "3"
                      ? "border-[#5ab9e5] border-[2px]  "
                      : "border-gray-300 "
                    }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[15%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                  }
                >
                  {tipoDoc === "3" && (
                    <CheckCircleIcon
                      className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                      aria-hidden="true"
                    />
                  )}
                  <div class=" w-[80px] transition-all  duration-300 ">
                    <img class="fill-orange-500 w-full object-contain h-[80px] " src={bancoVenezuela} alt="" />
                  </div>
                  <div class="flex h-full flex-col-reverse gap-4 w-full justify-center items-center ">
                    <span class="block text-lg" id="headlessui-label-:rt:"><span class="text-[#a0a0a0]   transition-all  duration-100 ">BDV</span></span>
                  </div>
                </button>
                <button
                  onClick={() => domiciliacionBanco(4)}
                  className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "4"
                      ? "border-[#5ab9e5] border-[2px]  "
                      : "border-gray-300 "
                    }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[15%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                  }
                >
                  {tipoDoc === "4" && (
                    <CheckCircleIcon
                      className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                      aria-hidden="true"
                    />
                  )}

                  <div class=" w-[80px] transition-all  duration-300 ">
                    <img class="fill-orange-500 w-full object-contain h-[80px] " src={mercantil} alt="" />
                  </div>
                  <div class="flex h-full flex-col-reverse gap-4 w-full justify-center items-center ">
                    <span class="block text-lg" id="headlessui-label-:rt:"><span class="text-[#a0a0a0]   transition-all  duration-100 ">Mercantil</span></span>
                  </div>
                </button>
                <button
                  onClick={() => domiciliacionBanco(5)}
                  className={`
                          w-full
                          justify-center 
                          items-center 
                          ${tipoDoc === "5"
                      ? "border-[#5ab9e5] border-[2px]  "
                      : "border-gray-300 "
                    }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[15%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                  }
                >
                  {tipoDoc === "5" && (
                    <CheckCircleIcon
                      className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                      aria-hidden="true"
                    />
                  )}
                  <div class=" w-[80px] transition-all  duration-300 ">
                    <img class="fill-orange-500 w-full object-contain h-[80px] " src={otroBanco} alt="" />
                  </div>
                  <div class="flex h-full flex-col-reverse gap-4 w-full justify-center items-center ">
                    <span class="block text-lg" id="headlessui-label-:rt:"><span class="text-[#a0a0a0]   transition-all  duration-100 ">Otros Bancos</span></span>
                  </div>
                </button>
                <div></div><div></div><div></div><div></div>
                <div className="lg:w-[30%] relative sha">
                  <div
                    className="bg-[#005dff0a] w-[300px] h-[400px] relative flex justify-center rounded-[5%]   before:content-[''] 
                    before:absolute 
                    before:w-[0px] 
                    before:h-[0px] 
                    before:rounded-full 
                    before:bg-white 
                    before:bottom-[-0px]
                    before:left-[-20px]
                    after:content-[''] 
                    after:absolute 
                    after:w-[0px] 
                    after:h-[20px] 
                    after:rounded-full 
                    after:bg-white 
                    after:bottom-[-20px]
                    after:right-[-20px] "
                  >
                    
                    <div
                      className={` bg-[url("../public/bgCard.jpg")] bg-right w-[60%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-17%] z-[8] p-[2rem]`}
                    >
                      <div className="flex w-full justify-center absolute top-0  right-0  ">
                        <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
                      </div>
                      <div className="flex justify-center items-center">
                        <div className="w-[70%] object-contain">
                          {/*{formSeleccione?.banco?.logo && (*/}
                          <img
                            className="w-full h-[150px] object-contain "
                            src={pagos}
                            alt=""
                          />
                          {/*} )}*/}
                        </div>
                      </div>
                      <div className="h-40% grid gap-[10px]">
                        <div className="font-medium text-center">
                          {descripDom}{" "}
                        </div>
                        <div className="flex flex-col justify-between items-center">
                          <div className="font-medium text-center ">
                            {" "}
                            <div className="whitespace-nowrap">
                              Número de cuenta
                            </div>{" "}
                          </div>
                          <div className="text-center"> {nroCuenta} </div>
                        </div>
                        <div className="flex flex-col justify-between items-center">
                          <div className="font-medium w-full text-center">
                            Moneda
                          </div>
                          <div className=" w-full text-center">
                            {"Bolívares"}{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white  rounded-md shadow mb-[100px]">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TypeDomiciliacionInst;